import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    documentList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    documentDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },

    employeeDocumentList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    employeeDocumentDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const documentSlice = createSlice({
  name: 'document',
  initialState,
  reducers: {
    getDocumentList: (state, action) => {
        state.documentList.requesting = true;
        state.documentList.error = null;
        state.documentList.items = [];
        state.documentList.success = false;
        state.documentList.filters = action.payload;
    },
    getDocumentListSuccess: (state, action) => {
        const { data, current_page, per_page, total} = action.payload;
        state.documentList.requesting = false;        
        state.documentList.items = data;
        state.documentList.success = true; 
        state.documentList.pagination.current_page = current_page;
        state.documentList.pagination.per_page = per_page;
        state.documentList.pagination.total = total;
    },
    getDocumentListFail: (state, action) => {        
        state.documentList.requesting = false;
        state.documentList.error = action.payload;
    },
    getDocumentDetails: (state) => {
        state.documentDetails.requesting = true;
        state.documentDetails.error = null;
        state.documentDetails.data = null;
        state.documentDetails.success = false; 
    },
    getDocumentDetailsSuccess: (state, action) => {
        state.documentDetails.requesting = false;
        state.documentDetails.data = action.payload;
        state.documentDetails.success = true; 
    },
    getDocumentDetailsFail: (state, action) => {        
        state.documentDetails.requesting = false;
        state.documentDetails.error = action.payload;
    },
    doDocumentCreate: (state) => {
        state.documentDetails.requesting = true;
        state.documentDetails.error = null;
        state.documentDetails.data = null;
        state.documentDetails.success = false; 
    },
    doDocumentUpdate: (state) => {
        state.documentDetails.requesting = true;
        state.documentDetails.error = null;
        state.documentDetails.data = null;
        state.documentDetails.success = false; 
    },
    doDocumentDelete: (state) => {
        state.documentDetails.requesting = true;
        state.documentDetails.error = null;
        state.documentDetails.data = null;
        state.documentDetails.success = false; 
    },
    //
    getEmployeeDocumentList: (state, action) => {
        state.employeeDocumentList.requesting = true;
        state.employeeDocumentList.error = null;
        state.employeeDocumentList.items = [];
        state.employeeDocumentList.success = false;
        state.employeeDocumentList.filters = action.payload;
    },
    getEmployeeDocumentListSuccess: (state, action) => {
        state.employeeDocumentList.requesting = false;        
        state.employeeDocumentList.items = action.payload;
        state.employeeDocumentList.success = true; 
    },
    getEmployeeDocumentListFail: (state, action) => {        
        state.employeeDocumentList.requesting = false;
        state.employeeDocumentList.error = action.payload;
    },
    getEmployeeDocumentDetails: (state) => {
        state.employeeDocumentDetails.requesting = true;
        state.employeeDocumentDetails.error = null;
        state.employeeDocumentDetails.data = null;
        state.employeeDocumentDetails.success = false; 
    },
    getEmployeeDocumentDetailsSuccess: (state, action) => {
        state.employeeDocumentDetails.requesting = false;
        state.employeeDocumentDetails.data = action.payload;
        state.employeeDocumentDetails.success = true; 
    },
    getEmployeeDocumentDetailsFail: (state, action) => {        
        state.employeeDocumentDetails.requesting = false;
        state.employeeDocumentDetails.error = action.payload;
    },

    doEmployeeDocumentCreate: (state) => {
        state.employeeDocumentDetails.requesting = true;
        state.employeeDocumentDetails.error = null;
        state.employeeDocumentDetails.data = null;
        state.employeeDocumentDetails.success = false; 
    },

    doEmployeeDocumentUpdate: (state) => {
        state.employeeDocumentDetails.requesting = true;
        state.employeeDocumentDetails.error = null;
        state.employeeDocumentDetails.data = null;
        state.employeeDocumentDetails.success = false; 
    },
    doEmployeeDocumentDelete: (state) => {
        state.employeeDocumentDetails.requesting = true;
        state.employeeDocumentDetails.error = null;
        state.employeeDocumentDetails.data = null;
        state.employeeDocumentDetails.success = false; 
    },
  },
})

export const { 
    getDocumentList, getDocumentListSuccess, getDocumentListFail,
    getDocumentDetails, getDocumentDetailsSuccess, getDocumentDetailsFail,
    doDocumentCreate, doDocumentUpdate, doDocumentDelete,
    getEmployeeDocumentList, getEmployeeDocumentListSuccess, getEmployeeDocumentListFail,
    getEmployeeDocumentDetails, getEmployeeDocumentDetailsSuccess, getEmployeeDocumentDetailsFail,
    doEmployeeDocumentCreate, doEmployeeDocumentUpdate, doEmployeeDocumentDelete
} = documentSlice.actions;

export default documentSlice.reducer;
